import { useState } from 'react'

import type { ZodType, z } from 'zod'

export function useZodForm<T extends ZodType>(schema: T, initialData: z.infer<T> extends Record<string, unknown> ? z.infer<T> : never) {
  const [formData, setFormData] = useState(initialData)
  const formParse = schema.safeParse(formData)

  // Note: this hook can be extended to include validation errors and validation functions

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  return {
    formData,
    setFormData,
    formParse,
    handleOnChange,
  }
}
